import Forms4i from "../../common/forms/forms25.js";
import StatusMessages from "../../common/helpers/statusmessage.js";
import BusyButton from "../../common/helpers/busybutton.js";

const messages = {
    Error: "There was an error with the form, please refresh and try again."
};

const loginForm = document.getElementById("registerForm");
const submitBtn = document.getElementById("btnSubmit");

async function init(){
    const form = new Forms4i();
    form.init({
        form: loginForm,
        submitButton: submitBtn,
        passwords: true,
        recaptcha: true,
        formAbandonment: true,
        onSuccess: () => submitSuccess(),
        onFailure: () => submitError()
    });
}

function submitSuccess(){
    BusyButton.show(submitBtn);
    loginForm.submit();
}

function submitError(){
    StatusMessages.showError(submitBtn, messages.Error);
}

await init(); 